/**
 * Утилита для определения слов с правильными окончаниями для чисел
 * @param number - число которое будем сравнивать
 * @param wordsArray - массив слов которые будем отдавать как результат. Например: ['продукт', 'продукта', 'продуктов']
 * @param locale - локаль пользователя, для латиницы достаточно двух вариантов множественных навзваний
 * */
export const getPlural = (number: number, wordsArray: string[], locale = 'ru') => {
  if (!Number.isFinite(number) || !wordsArray || !Array.isArray(wordsArray)) return '';

  if (locale !== 'ru') {
    const pluralIndex = number === 1 ? 0 : 1;

    return wordsArray[pluralIndex] || '';
  }

  const keys = [2, 0, 1, 1, 1, 2];
  const mod = number % 100;
  const pluralIndex = mod > 7 && mod < 20 ? 2 : keys[Math.min(mod % 10, 5)];
  return wordsArray[pluralIndex] || '';
};
